import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';

class Content extends PureComponent {
  static contextTypes = {
    deviceType: PropTypes.string
  };

  static propTypes = {
    reverse: PropTypes.bool.isRequired
  };

  static defaultProps = {
    reverse: false
  };

  render() {
    require('./Content.styl');
    const { deviceType } = this.context;
    const { reverse, ...props } = this.props;

    return (
      <div
        className={`Content ${reverse ? 'Content--reverse' : ''}`}
        {...props}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/Content.js